<template>
  <div>
    <NavigatorItem
      :indent="indent"
      :navigation="navigation"
      :selectedObjectId="selectedObjectId"
      @updateNavigation="updateNavigation($event)"
    />
  </div>
</template>

<script>
import NavigatorItem from "@/components/document/revision/navigator/NavigatorItem";
export default {
  name: "InlineObject",
  props: ["navigation", "indent", "selectedObjectId"],
  components: { NavigatorItem },
  methods: {
    updateNavigation(navigation) {
      //   console.log(navigation);
      this.$emit("updateNavigation", navigation);
    }
  }
};
</script>